import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Notificationpreference } from '../model/notificationpreference';

@Injectable({
  providedIn: 'root'
})
export class ProjectnotificationService {

  constructor(private http:HttpClient) { }
 // /project/{projectId}/person/{personId}/notification/
       
  getNotificationPreferences(projectId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Notificationpreference[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+"/person/"+personId.substr(0,36)+"/notification",httpOptions);
  }
  setNotificationPreferences(notificationpreference:Notificationpreference){
    //console.log('notf pref fro service', notificationpreference)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+notificationpreference.projectId+"/person/"+notificationpreference.personId.substr(0,36)+"/notification/"+notificationpreference.preference,JSON.stringify(notificationpreference),httpOptions);
  }
}
